import React from 'react';
import ReactECharts from 'echarts-for-react';

const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'


const ProjectSlippagePercentageChart = ({ label, slippageKey, chartData, chartHeight, chartHeading, xAxisTitle = '', yAxisTitle = '' }) => {
    const isEmpty = !chartData || chartData.length === 0;
    console.log(xAxisTitle, "xAxisTitle")
    const categories = chartData ? chartData.map(item => item[label]) : [];
    const slippageValues = chartData ? chartData.map(item => Math.max(0, item[slippageKey] || 0)) : [];

    const option = {
        title: {
            text: chartHeading || 'Projects Health: Average Slippage (%)',
            subtext: 'Average Slippage Percentage across project team members',
            left: 'center',
            textStyle: { fontSize: 14, fontWeight: 'bold', color: '#111' },
            subtextStyle: { fontSize: 11, color: '#666' }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: (params) => {
                const idx = params[0].dataIndex;
                const item = chartData[idx];
                const val = Math.max(0, item[slippageKey] || 0);
                const status = val === 0 ? 'On Schedule' : val <= 10 ? 'Minor Delay' : 'Significant Delay';
                return `<strong>${item[label]}</strong>

                        Average Slippage: ${val.toFixed(1)}%

                        Status: ${status}`;
            }
        },
        grid: {
            top: '15%',
            left: '5%',
            right: '8%',
            bottom: '12%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: categories,
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 100,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                fontSize: 11,
                fontWeight: "600",
                color: labelColor,
                rotate: 35, // Reduce to 0 if labels are short
            },
        },
        yAxis: {
            type: 'value',
            min: 0,
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 40,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisTick: {
                show: false,
            },
            splitLine: {
                lineStyle: {
                    type: 'dashed',
                    color: '#e0e0e0',
                },
            },
            axisLabel: {
                formatter: '{value}%',
                color: labelColor,
                fontSize: 11,
            },
        },
        series: [
            {
                name: 'Slippage %',
                type: 'bar',
                barWidth: 30, // Width in pixels
                barCategoryGap: "20%",
                data: slippageValues.map(val => ({
                    value: val,
                    itemStyle: {
                        color: val === 0 ? '#2ECC71' : val <= 10 ? '#F59E0B' : '#E87A5D',
                        borderRadius: [4, 4, 0, 0]
                    }
                })),
                label: {
                    show: true,
                    position: 'top',
                    formatter: (params) => `${params.value.toFixed(1)}%`,
                    fontSize: 10,
                    fontWeight: 'bold',
                    color: '#333'
                }
            }
        ]
    };

    return (
        <div style={{ width: '100%', background: '#fff', padding: '15px', borderRadius: '8px' }}>
            {isEmpty ? (
                <div style={{ height: chartHeight || '500px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#888' }}>
                    No Data Available
                </div>
            ) : (
                <div
                    style={{
                        height: chartHeight || '400px',
                        width: '100%',
                        background: "#fff",
                        borderRadius: 12,
                        padding: 10,
                        boxShadow: "0 2px 8px rgba(0,0,0,.08)",
                    }}
                >
                    <ReactECharts
                        option={option}
                        style={{
                            height: 600,
                            width: '100%',
                        }}
                    />

                    {/* Status Key Footer */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '20px',
                        marginTop: '5px',
                        fontSize: '12px',
                        fontWeight: '600'
                    }}>
                        {/* <div style={{ display: 'flex', alignItems: 'center', gap: '15px', fontSize: '12px', fontWeight: '600', color: '#333' }}> */}
                        <span>Status Key:</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <span style={{ width: '10px', height: '10px', backgroundColor: '#2ECC71', display: 'inline-block', borderRadius: '2px' }}></span>
                            <span>On Schedule (0%)</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <span style={{ width: '10px', height: '10px', backgroundColor: '#F59E0B', display: 'inline-block', borderRadius: '2px' }}></span>
                            <span>Minor Delay (&le;10%)</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                            <span style={{ width: '10px', height: '10px', backgroundColor: '#E87A5D', display: 'inline-block', borderRadius: '2px' }}></span>
                            <span>High Delay (&gt;10%)</span>
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjectSlippagePercentageChart;